import React, { useEffect, useRef } from "react";
import useCheckMobileScreen from "./useCheckMobileScreen";
import {
  LineChart,
  Line,
  ReferenceArea,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
  Label,
} from "recharts";
import { Prompt, useHistory, useLocation } from "react-router-dom";
import {
  calculateDailyEnergyArrays,
  calculateDailySummary,
} from "./common/calculationHelper.js";
import { useStateIfMounted } from "use-state-if-mounted";
import "./../../../css/app.css";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import {
  manageRequest,
  fetchLogsFromServer,
  returnedsurflogStatus,
  translateJsonFileName,
  translateBinFileName,
  calculateTotalProgress,
} from "../../../core/tools.js";
import { surfLogParsingEngine } from "./../../../core/dataParser.js";
import { useAlert } from "react-alert";

const appparameters = require("../../../core/common.jsx");

let timezone = "";
const Chart = (props) => {
  const alert = useAlert();
  const location = useLocation();
  const containsCON05 = location.pathname.includes("COND05"); //COND05
  //console.log("containsCON05:" + containsCON05);
  let chartInterval = useCheckMobileScreen() ? 35 : 11;
  const [data, setData] = useStateIfMounted([]);
  const [now, setNow] = useStateIfMounted(0);
  const [startDate, setStartDate] = useStateIfMounted(
    new Date().toISOString().split("T")[0],
  );
  const startDateRef = useRef(startDate); // Create a ref to hold the latest startDate value
  const [devicedate, setDevicedate] = useStateIfMounted(
    new Date().toISOString().split("T")[0],
  );
  let intervalforget24hourslogtodevice = undefined;
  const [totaledlimported, settotaledlimported] = useStateIfMounted("N/A");
  const [datafound, setdatafound] = useStateIfMounted(true);
  const [totaledlexported, settotaledlexported] = useStateIfMounted("N/A");
  const [displayedDataKeys, setDisplayedDataKeys] = useStateIfMounted([
    "EDL kW",
    "PV kW",
    "Genset kW",
    "Consumption Kw",
    "Battery Capacity",
    "Load1",
    "Load2",
    "Load3",
    "ongrid pv Kw",
    "hyb pv Kw",
  ]);
  const [xData, setxData] = useStateIfMounted([
    "24",
    "22",
    "20",
    "18",
    "16",
    "14",
    "12",
    "10",
    "8",
    "6",
    "4",
    "2",
    "0",
  ]);
  const [hybridInverterLabel, sethybridInverterLabel] = useStateIfMounted([
    "Inv1 PV1 KW",
    "Inv1 PV2 KW",
    "Inv2 PV1 KW",
    "Inv2 PV2 KW",
    "Inv3 PV1 KW",
    "Inv3 PV2 KW",
    "Inv4 PV1 KW",
    "Inv4 PV2 KW",
    "Inv5 PV1 KW",
    "Inv5 PV2 KW",
    "Inv6 PV1 KW",
    "Inv6 PV2 KW",
  ]);
  const [ongridInverterLabel, setOngridInverterLabel] = useStateIfMounted([
    "Inv1 Out KW",
    "Inv2 Out KW",
    "Inv3 Out KW",
    "Inv4 Out KW",
    "Inv5 Out KW",
    "Inv6 Out KW",
    "Inv7 Out KW",
    "Inv8 Out KW",
    "Inv9 Out KW",
    "Inv10 Out KW",
  ]);
  const [maxipowerdatareached, setmaxipowerdatareached] = useStateIfMounted(0);
  const [minipowerdatareached, setminipowerdatareached] = useStateIfMounted(0);
  const [requestCheck, setRequestCheck] = useStateIfMounted(false);
  const [listoflogfiles, setListoflogfiles] = useStateIfMounted(null);
  const [jsonFilesContent, setJsonFilesContent] = useStateIfMounted(null);
  const [dataFilesContent, setDataFilesContent] = useStateIfMounted(null);
  const [loadingStatus, setLoadingStatus] = useStateIfMounted("");
  const [surflogStatus, setSurflogStatus] = useStateIfMounted(
    returnedsurflogStatus,
  );
  const [productionResults, setProductionResults] = useStateIfMounted(null);
  const [consumptionResults, setConsumptionResults] = useStateIfMounted(null);
  const [dailyEnergySummary, setDailyEnergySummary] = useStateIfMounted(null);
  const mac = props.mac; //"0-5a-48";
  let logstopic = mqtt_topics.fixed_topic_part + mac + "/LogRetrieve";
  //const sasmac = "0-5c-98"; //0-5c-98
  const minbatterycapacity = 20;
  const deviceSDRetrieveCompatible =
    localStorage.getItem("lr_of_" + mac) == "1";
  //const maxpowerproduction = 60;
  //const maxreturnedpower = -20;
  useEffect(() => {
    async function setstartdateasdevicedate() {
      setStartDate(formatLocalDateToYYYYMMDD(new Date(await getdevicedate())));
    }
    //console.log("setstartdateasdevicedate");
    setstartdateasdevicedate();
  }, []);

  function formatLocalDateToYYYYMMDD(localDate) {
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
    const day = String(localDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Format YYYY-MM-DD
  }
  // Update the ref whenever startDate changes
  useEffect(() => {
    startDateRef.current = startDate;
    //console.log("startDate changed:" + startDate);
  }, [startDate]);

  useEffect(() => {
    if (containsCON05) {
      localStorage.setItem("designtype_of_" + "0-6d-52", "FSHYB");
      localStorage.setItem("lr_of_" + "0-6d-52", "1");
      localStorage.setItem("type_of_" + "0-6d-52", "AMFES");
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      //console.log("fetchData");
      try {
        let date = await getdevicedate();
        //console.log("browser date:" + new Date());
        //console.log("device date:" + date);
        setDevicedate(date);

        const designType = localStorage
          .getItem("designtype_of_" + mac)
          .toLocaleUpperCase();

        if (designType.includes("FS") && loadingStatus === "") {
          //console.log("designType:" + designType);
          //console.log("deviceSDRetrieveCompatible:" + deviceSDRetrieveCompatible);
          //console.log("start date:" + startDateRef.current);
          //console.log("is today:" + istoday(new Date(startDateRef.current), date));
          if (
            (designType.toUpperCase() === "FSHYBRBS" ||
              deviceSDRetrieveCompatible) &&
            !istoday(startDateRef.current, date)
          ) {
            //console.log("do nothing");
            // No operation needed, as your conditions dictate
          } else {
            if (istoday(startDateRef.current, date)) {
              //console.log("get24hourslogtodevice");
              get24hourslogtodevice(date);
            }
          }
        }
      } catch (error) {
        //console.error("Error fetching data:", error);
      }
      // Clear any existing intervals before setting a new one
      if (intervalforget24hourslogtodevice) {
        clearInterval(intervalforget24hourslogtodevice);
      }

      intervalforget24hourslogtodevice = setInterval(async () => {
        fetchData();
      }, 50000); // Adjust this interval as needed
    }

    fetchData();

    // Cleanup interval on component unmount
    return () => {
      if (intervalforget24hourslogtodevice) {
        clearInterval(intervalforget24hourslogtodevice);
      }
    };
  }, [displayedDataKeys]);

  function subscribeAndListenToMqttMessages() {
    if (props.mqttClient != undefined) {
      // Subscribe to the topic and set up the message handler
      props.mqttClient.subscribe(logstopic);
      props.mqttClient.on("message", handleMqttMessage);
    }
  }

  function unsubscribeAndDoNotListenToMqttMessages() {
    if (props.mqttClient != undefined) {
      props.mqttClient.unsubscribe(logstopic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    }
  }

  function handleMqttMessage(topic, message) {
    if (topic == logstopic) {
      message = JSON.parse(message.toString());
      if (message.LogRetrieveStatus.includes(surflogStatus[3])) {
        //"Uploading Files Started"
        setLoadingStatus(
          "Uploading Files " +
            calculateTotalProgress(
              message.TotalFilesNumber,
              message.CurrentSendingFileIndex,
              message.FileUploadProgress,
            ) +
            "%",
        );
      } else {
        unsubscribeAndDoNotListenToMqttMessages();
        if (
          message.LogRetrieveStatus == surflogStatus[5] ||
          message.LogRetrieveStatus == surflogStatus[6]
        ) {
          //failed upload
          setLoadingStatus("");
          finishedretrievinglogsfromsdcard();
          //unsubscribeAndDoNotListenToMqttMessages();
          alert.show(message.LogRetrieveStatus, {
            type: "error",
            timeout: 0,
            position: "middle",
          });
        } else {
          //suceesfull upload
          if (message.LogRetrieveStatus == surflogStatus[4]) {
            startFetchingDirectoriesOnServer();
          } else {
            setLoadingStatus("");
            finishedretrievinglogsfromsdcard();
            //unsubscribeAndDoNotListenToMqttMessages();
            alert.show(message.LogRetrieveStatus, {
              type: "info",
              timeout: 0,
              position: "middle",
            });
          }
        }
      }
    }
  }

  const startFetchingDirectoriesOnServer = async () => {
    setLoadingStatus("Fetching Directories ...");
    try {
      //await new Promise((resolve) => setTimeout(resolve, 50)); // Small delay
      const list_of_files_to_retrieve = await fetchLogsFromServer(
        "listoflogfiles.txt",
        mac,
      );
      if (list_of_files_to_retrieve) {
        let filesArray = list_of_files_to_retrieve.split("\n");
        setListoflogfiles(filesArray.length - 1);
        for (
          let fileindex = 0;
          fileindex < filesArray.length - 1;
          fileindex++
        ) {
          let data = await fetchLogsFromServer(filesArray[fileindex], mac);
          if (data) {
            if (
              filesArray[fileindex]
                .slice(((filesArray[fileindex].lastIndexOf(".") - 1) >>> 0) + 2)
                .toLowerCase() === "jsn"
            ) {
              setJsonFilesContent((prevJsonFilesContent) => ({
                ...prevJsonFilesContent,
                [translateJsonFileName(filesArray[fileindex])]: data,
              }));
            } else {
              setDataFilesContent((prevDataFilesContent) => ({
                ...prevDataFilesContent,
                [translateBinFileName(filesArray[fileindex])]: data.data,
              }));
            }
          }
          //await new Promise((resolve) => setTimeout(resolve, 50)); // Small delay
        }
      } else {
        alert.show("No datalog Found", {
          type: "info",
          timeout: 0,
          position: "middle",
        });
        finishedretrievinglogsfromsdcard();
      }
    } catch (error) {
      console.error("Error fetching directories:", error);
      alert.show("An error occurred while retrieving logs.", {
        type: "error",
        timeout: 0,
        position: "middle",
      });
    } finally {
      finishedretrievinglogsfromsdcard();
    }
  };

  useEffect(() => {
    if (
      dataFilesContent !== null &&
      jsonFilesContent !== null &&
      listoflogfiles !== null
    ) {
      console.log("Checking conditions...");
      console.log("dataFilesContent:", Object.keys(dataFilesContent).length);
      console.log("jsonFilesContent:", Object.keys(jsonFilesContent).length);
      console.log("listoflogfiles:", listoflogfiles);
    }
    if (
      dataFilesContent !== null &&
      jsonFilesContent !== null &&
      listoflogfiles !== null &&
      Object.keys(dataFilesContent).length +
        Object.keys(jsonFilesContent).length ==
        listoflogfiles
    ) {
      handleExecute(jsonFilesContent, dataFilesContent);
    }
  }, [dataFilesContent, jsonFilesContent]);

  const handleExecute = async (data, json) => {
    setLoadingStatus("Parsing Data ...");
    await new Promise((resolve) => setTimeout(resolve, 50));
    try {
      // Execute the async operation
      const output = await surfLogParsingEngine(data, json);
      if (output.error) {
        alert.show("Failed to parse data error:" + output.error, {
          type: "error",
          timeout: 0, // Alert stays visible until dismissed
          position: "middle",
        });
        await new Promise((resolve) => setTimeout(resolve, 50)); // Small delay
      } else {
        if (output.value !== "" && output.value !== undefined) {
          setLoadingStatus("Handle Drawing ...");
          await new Promise((resolve) => setTimeout(resolve, 50));
          mapSDChartLogToDrawingData(parseStringToData(output.value));
        } else {
          alert.show("Failed to parse data", {
            type: "error",
            timeout: 0,
            position: "middle",
          }); // Alervvt stays visible until dismissed// Alert stays visible until dismissed
          await new Promise((resolve) => setTimeout(resolve, 50)); // Small delay
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingStatus("");
      finishedretrievinglogsfromsdcard();
    }
  };

  function parseStringToData(inputString, maxSize = 288) {
    // Split the input string by '\n' to get rows
    const rows = inputString.trim().split("\n");

    // Split the first row to get headers
    const headers = rows[0].split("\t");

    // Initialize an object to hold the grouped data
    const groupedData = {};

    // Create an empty array for each header
    headers.forEach((header) => {
      groupedData[header] = [];
    });

    // Loop through the remaining rows to populate the grouped data arrays
    for (let i = 1; i < rows.length && i <= maxSize; i++) {
      const values = rows[i].split("\t");

      headers.forEach((header, index) => {
        if (groupedData[header].length < maxSize) {
          groupedData[header].push(values[index]);
        }
      });
    }

    return groupedData;
  }

  function mapSDChartLogToDrawingData(data) {
    let date = new Date(startDateRef.current);
    setdatafound(data != undefined);
    let returntimetoindexofconstantminutes = Math.round(
      (date.getHours() * 60 * 60 + date.getMinutes() * 60 + date.getSeconds()) /
        (mqtt_topics.requestdataforcond05intervalinmillisec / 1000),
    );
    let timeoutframe = 5; //5mins
    let edlkwpoints = [];
    let gensetkwpoints = [];
    let pvkwpoints = [];
    let loadkwpoints = [];
    let battcappoints = [];
    let Load1points = [];
    let Load2points = [];
    let Load3points = [];
    let totaledlin = 0;
    let totaledlout = 0;
    let loopinghours;
    let maxlocalpowerreached = 0;
    let minlocalpowerreached = 0;
    let totalpvproduction = 0;
    let choosepvarrayaccordinftoinvertertype;
    if (localStorage.getItem("designtype_of_" + mac).toUpperCase() == "FSOG") {
      choosepvarrayaccordinftoinvertertype = ongridInverterLabel;
    } else {
      //FSHYB
      choosepvarrayaccordinftoinvertertype = hybridInverterLabel;
    }
    for (let index = 0; index < 288; index++) {
      loopinghours = convertSecondsToHMS(index * timeoutframe * 60);
      edlkwpoints[index] = {
        y:
          data["Grid Power(KW)"] != undefined
            ? data["Grid Power(KW)"][index]
            : null,
        x: loopinghours,
      };
      gensetkwpoints[index] = {
        y:
          data["Genset Power(KW)"] != undefined
            ? data["Genset Power(KW)"][index] < -1000
              ? null
              : data["Genset Power(KW)"][index]
            : null,
        x: loopinghours,
      };
      totalpvproduction = 0;
      for (
        let inverterindex = 0;
        inverterindex < choosepvarrayaccordinftoinvertertype.length;
        inverterindex++
      ) {
        totalpvproduction +=
          data[choosepvarrayaccordinftoinvertertype[inverterindex]] != undefined
            ? Number(
                data[choosepvarrayaccordinftoinvertertype[inverterindex]][
                  index
                ],
              ) > 1000
              ? 0
              : Number(
                  data[choosepvarrayaccordinftoinvertertype[inverterindex]][
                    index
                  ],
                )
            : 0;
      }
      pvkwpoints[index] = {
        y: totalpvproduction.toFixed(2),
        x: loopinghours,
      };
      loadkwpoints[index] = {
        y:
          data["Load Power(KW)"] != undefined
            ? data["Load Power(KW)"][index]
            : null,
        x: loopinghours,
      };
      battcappoints[index] = {
        y:
          data["Battery Capacity"] != undefined
            ? data["Battery Capacity"][index]
            : null,
        x: loopinghours,
      };
      if (localStorage.getItem("designtype_of_" + mac) == "FSHYBRBS") {
        Load1points[index] = {
          y: data["Load1"] != undefined ? data["Load1"][index] : null,
          x: loopinghours,
        };
        Load2points[index] = {
          y: data["Load3"] != undefined ? data["Load3"][index] : null,
          x: loopinghours,
        };
        Load3points[index] = {
          y: data["Load3"] != undefined ? data["Load3"][index] : null,
          x: loopinghours,
        };
      }

      //calculated maximum power reached
      if (
        data["Grid Power(KW)"] != undefined &&
        Number(data["Grid Power(KW)"][index]) > maxlocalpowerreached
      ) {
        maxlocalpowerreached = Number(data["Grid Power(KW)"][index]);
      }
      if (
        data["Genset Power(KW)"] != undefined &&
        Number(data["Genset Power(KW)"][index]) > maxlocalpowerreached
      ) {
        maxlocalpowerreached = Number(data["Genset Power(KW)"][index]);
      }
      if (
        (Number(totalpvproduction) > 1000 ? 0 : Number(totalpvproduction)) >
        maxlocalpowerreached
      ) {
        maxlocalpowerreached = Number(totalpvproduction);
      }
      if (
        data["Load Power(KW)"] != undefined &&
        Number(data["Load Power(KW)"][index]) > maxlocalpowerreached
      ) {
        maxlocalpowerreached = Number(data["Load Power(KW)"][index]);
      }

      //calculated the minimum power reached
      if (
        data["Grid Power(KW)"] != undefined &&
        Number(data["Grid Power(KW)"][index]) < minlocalpowerreached
      ) {
        minlocalpowerreached = Number(data["Grid Power(KW)"][index]);
      }
      if (
        data["Genset Power(KW)"] != undefined &&
        (Number(data["Genset Power(KW)"][index]) < -1000
          ? 0
          : Number(data["Genset Power(KW)"][index])) < minlocalpowerreached
      ) {
        minlocalpowerreached = Number(data["Genset Power(KW)"][index]);
      }
      if (Number(totalpvproduction) < minlocalpowerreached) {
        minlocalpowerreached = Number(totalpvproduction);
      }
      if (
        data["Load Power(KW)"] != undefined &&
        Number(data["Load Power(KW)"][index]) < minlocalpowerreached
      ) {
        minlocalpowerreached = Number(data["Load Power(KW)"][index]);
      }

      //calculate totaledlimported
      if (
        data["Grid Power(KW)"] != undefined &&
        data["Grid Power(KW)"][index] != null &&
        data["Grid Power(KW)"][index] != undefined &&
        data["Grid Power(KW)"][index] != ""
      ) {
        //&& index <= returntimetoindexofconstantminutes
        if (data["Grid Power(KW)"][index] > 0) {
          //imported
          totaledlin += Number(data["Grid Power(KW)"][index]) / 12;
        } else {
          //exported
          totaledlout += Number(data["Grid Power(KW)"][index]) / 12;
        }
      }
    }
    settotaledlexported(totaledlout.toFixed(2) + " Kwh");
    settotaledlimported(totaledlin.toFixed(2) + " Kwh");
    let tempdata = [];
    if (
      localStorage
        .getItem("type_of_" + mac)
        .toLowerCase()
        .indexOf("amf") !== -1
    ) {
      tempdata.push({
        id: "EDL kW",
        name: "EDL kW",
        color: "steelblue",
        points: displayedDataKeys.includes("EDL kW") ? edlkwpoints : [],
      });
    }
    tempdata.push({
      id: "PV kW",
      name: "PV kW",
      color: "green",
      points: displayedDataKeys.includes("PV kW") ? pvkwpoints : [],
    });
    tempdata.push({
      id: "Genset kW",
      name: "Genset kW",
      color: "coral",
      points: displayedDataKeys.includes("Genset kW") ? gensetkwpoints : [],
    });
    tempdata.push({
      id: "Consumption Kw",
      name: "Consumption Kw",
      color: "purple",
      points: displayedDataKeys.includes("Consumption Kw") ? loadkwpoints : [],
    });
    if (
      localStorage.getItem("designtype_of_" + mac) == "FSHYB" ||
      localStorage.getItem("designtype_of_" + mac) == "FSCOMPHYB" ||
      localStorage.getItem("designtype_of_" + mac) == "FSHYBRBS"
    ) {
      tempdata.push({
        id: "Battery Capacity",
        name: "Battery Capacity",
        color: "olive",
        points: displayedDataKeys.includes("Battery Capacity")
          ? battcappoints
          : [],
      });
    }
    if (localStorage.getItem("designtype_of_" + mac) == "FSHYBRBS") {
      tempdata.push({
        id: "Load1",
        name: "Load1",
        color: "orange",
        points: displayedDataKeys.includes("Load1") ? Load1points : [],
      });
      tempdata.push({
        id: "Load2",
        name: "Load2",
        color: "palegreen",
        points: displayedDataKeys.includes("Load2") ? Load2points : [],
      });
      tempdata.push({
        id: "Load3",
        name: "Load3",
        color: "powderblue",
        points: displayedDataKeys.includes("Load3") ? Load3points : [],
      });
    }
    setNow(
      convertSecondsToHMS(
        returntimetoindexofconstantminutes * timeoutframe * 60,
      ),
    );
    //console.log(tempdata);
    setData(tempdata);
    if (localStorage.getItem("designtype_of_" + mac) == "FSHYBRBS") {
      setminipowerdatareached(Math.floor(minlocalpowerreached / 1) * 1);
      setmaxipowerdatareached(Math.ceil(maxlocalpowerreached / 1) * 1);
    } else {
      setminipowerdatareached(Math.floor(minlocalpowerreached / 5) * 5);
      setmaxipowerdatareached(Math.ceil(maxlocalpowerreached / 5) * 5);
    }
  }

  function finishedretrievinglogsfromsdcard() {
    setListoflogfiles(null);
    setJsonFilesContent(null);
    setDataFilesContent(null);
    setRequestCheck(false);
    removesurflog();
    manageRequest(
      "delete",
      "Get Log",
      localStorage.getItem("token"),
      localStorage.getItem("username"),
      mqtt_topics.choosenmac,
    );
  }

  function getLocalDateString(date, timeZone) {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date); // "YYYY-MM-DD"
  }

  function istoday(dateInputString, deviceDate) {
    console.log(
      "inputDateStr:" + dateInputString + " deviceDate:" + deviceDate,
    );
    const [y, m, d] = dateInputString.split("-").map(Number);
    const inputDate = new Date(y, m - 1, d); // Local date, no timezone shift

    const devDate = new Date(deviceDate); // Already represents device local time (in JS Date format)

    return (
      inputDate.getFullYear() === devDate.getFullYear() &&
      inputDate.getMonth() === devDate.getMonth() &&
      inputDate.getDate() === devDate.getDate()
    );
  }

  /*function istoday(date, devicedate) {
    //Normalize to UTC or a Target Time Zone
    return (
      date.getUTCDate() === devicedate.getUTCDate() &&
      date.getUTCMonth() === devicedate.getUTCMonth() &&
      date.getUTCFullYear() === devicedate.getUTCFullYear()
    );
  }*/

  /*function istoday(date, devicedate) {
    const currentDate = devicedate; //new Date();
    //console.log("date:" + date + " devicedate:" + currentDate);
    //console.log("day:" + date.getDate() + " day:" + currentDate.getDate());
    //console.log("month:" + date.getMonth() + " month:" + currentDate.getMonth());
    //console.log("year:" + date.getFullYear() + " year:" + currentDate.getFullYear());
    // Check if the date is today
    const isTodayDate =
      date.getDate() === currentDate.getDate() &&
      date.getMonth() === currentDate.getMonth() &&
      date.getFullYear() === currentDate.getFullYear();
    return isTodayDate;
  }*/

  const gettimeaccordingtositelocation = async () => {
    if (
      containsCON05 ||
      (localStorage.getItem("designtype_of_" + mac) &&
        localStorage.getItem("designtype_of_" + mac).includes("FS"))
    ) {
      let location = "33.888630,35.495480"; //lebanon
      let defaulttimezone = "Asia/Beirut";
      let surf_timezone = localStorage.getItem("timezone_of_" + mac);
      //console.log("surf_timezone_" + surf_timezone);
      let getlocation = true;
      if (
        mqtt_topics.latitude != undefined &&
        mqtt_topics.latitude != "" &&
        mqtt_topics.longitude != undefined &&
        mqtt_topics.longitude != ""
      ) {
        location = mqtt_topics.latitude + "," + mqtt_topics.longitude; //latitude,longtitude
      } else if (
        surf_timezone != "undefined" &&
        surf_timezone != undefined &&
        surf_timezone != ""
      ) {
        getlocation = false;
      }
      //if (getlocation) {
      //console.log("get geolocation true" + surf_timezone);
      try {
        const response = await fetch(
          `https://api.wheretheiss.at/v1/coordinates/${location}`,
        );
        const weatherdata = await response.json();
        if (
          weatherdata != undefined &&
          weatherdata.timezone_id != undefined &&
          weatherdata.timezone_id != ""
        ) {
          return weatherdata.timezone_id;
        }
      } catch (error) {
        //console.log("error_" + error);
        return defaulttimezone;
      }
      //} else {
      //console.log("returned surf timezone" + surf_timezone.trim());
      //return surf_timezone.trim();
      //}
    }
  };

  const removesurflog = async () => {
    try {
      const response = await fetch(
        appparameters.backend_app_url + `/frontend/removeSurfLogs`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userData: {
              tag: mac,
              token: localStorage.getItem("token"),
              username: localStorage.getItem("username"),
            },
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.content) {
        return data.content;
      } else {
        console.error("No content in response");
        return null;
      }
    } catch (error) {
      console.error("Error fetching file content:", error);
      return null;
    }
  };

  //when componenet unmount
  useEffect(
    () => () => {
      //clearInterval(intervalforget24hourslogtodevice);
      unsubscribeAndDoNotListenToMqttMessages();
    },
    [],
  );

  function adjustUTCDateByOffset(offset) {
    if (offset != undefined && offset != "" && offset.toLowerCase() == "utc") {
      offset = "U+0";
    }

    const offsetMatch = offset != undefined && offset.match(/^U([+\-]\d+)$/);

    if (offsetMatch) {
      const hoursOffset = parseInt(offsetMatch[1], 10);
      const currentLocalDate = new Date(); // Get current local date
      //console.log("currentLocalDate_" + currentLocalDate.toISOString());

      const currentUtcTimestamp =
        currentLocalDate.getTime() +
        currentLocalDate.getTimezoneOffset() * 60000;
      const adjustedDate = new Date(
        currentUtcTimestamp + hoursOffset * 3600000,
      );

      //console.log("adjustedDate_" + adjustedDate.toISOString());
      return adjustedDate;
    } else {
      console.error(
        "Invalid UTC offset format. Use U+n or U-n, where n is an integer.",
      );
      // Returning the current local date if the offset is invalid
      return new Date();
    }
  }

  async function get24hourslogtodevice(date) {
    let body = {};
    if (
      localStorage.getItem("designtype_of_" + mac).toLocaleUpperCase() ==
      "FSHYBRBS"
    ) {
      body = { mac: mac, date: new Date(startDateRef.current).getTime() };
    } else {
      body = { mac: mac };
    }
    //console.log(body);
    await fetch(
      appparameters.backend_app_url + "/frontend/get24hourslogtodevice",
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      },
    )
      .then((res) => res.json())
      .then(async (response) => {
        //console.log("request result from get24hourslogtodevice ");
        //console.log(response);
        setdatafound(Object.keys(response).length != 0);
        if (response == undefined || Object.keys(response).length === 0) {
          //do nothing
          setdatafound(false);
        } else {
          //let date = await getdevicedate();
          //console.log("date_" + date + "_instanttimezone_" + instanttimezone);
          let returntimetoindexofconstantminutes = Math.round(
            (date.getHours() * 60 * 60 +
              date.getMinutes() * 60 +
              date.getSeconds()) /
              (mqtt_topics.requestdataforcond05intervalinmillisec / 1000),
          );
          //console.log("date_" + date);
          let timeoutframe = 5; //5mins
          let edlkwpoints = [];
          let gensetkwpoints = [];
          let pvkwpoints = [];
          let loadkwpoints = [];
          let battcappoints = [];
          let Load1points = [];
          let Load2points = [];
          let Load3points = [];
          let OGIPVpoints = [];
          let HybPVpoints = [];
          let totaledlin = 0;
          let totaledlout = 0;
          let loopinghours;
          let maxlocalpowerreached = 0;
          let minlocalpowerreached = 0;
          let totalpvproduction = null;
          if (response != undefined && response.log != undefined) {
            response = response.log;
          }
          for (let index = 0; index <= 288; index++) {
            //response.edlkw.length
            //loopinghours = Number((index * timeoutframe) / 60).toFixed(2);
            loopinghours = convertSecondsToHMS(index * timeoutframe * 60);
            //console.log("loopinghours:" + loopinghours);
            edlkwpoints[index] = {
              y: response.edlkw[index],
              x: loopinghours,
            };
            //limit -1000
            gensetkwpoints[index] = {
              y:
                Number(response.gensetkw[index]) < -1000
                  ? null
                  : response.gensetkw[index],
              x: loopinghours,
            };
            //limit 1000
            if (localStorage.getItem("designtype_of_" + mac) != "FSCOMPHYB") {
              pvkwpoints[index] = {
                y:
                  Number(response.pvkw[index]) > 1000
                    ? null
                    : response.pvkw[index],
                x: loopinghours,
              };
            } else {
              //total pv production when complex dispalying
              totalpvproduction = (
                Number(response.ogpvkw[index]) + Number(response.hybpvkw[index])
              ).toFixed(2);
              pvkwpoints[index] = {
                y:
                  totalpvproduction > 1000 ||
                  totalpvproduction == "NaN" ||
                  totalpvproduction == 0 ||
                  totalpvproduction == undefined
                    ? null
                    : totalpvproduction,
                x: loopinghours,
              };
            }
            loadkwpoints[index] = {
              y: response.loadkw[index],
              x: loopinghours,
            };
            battcappoints[index] = {
              y: response.battcap[index],
              x: loopinghours,
            };
            if (localStorage.getItem("designtype_of_" + mac) == "FSHYBRBS") {
              Load1points[index] = {
                y: response.Load1[index],
                x: loopinghours,
              };
              Load2points[index] = {
                y: response.Load2[index],
                x: loopinghours,
              };
              Load3points[index] = {
                y: response.Load3[index],
                x: loopinghours,
              };
            } else if (
              localStorage.getItem("designtype_of_" + mac) == "FSCOMPHYB"
            ) {
              OGIPVpoints[index] = {
                y: response.ogpvkw[index],
                x: loopinghours,
              };
              HybPVpoints[index] = {
                y: response.hybpvkw[index],
                x: loopinghours,
              };
            }

            //calculated maximum power reached
            if (Number(response.edlkw[index]) > maxlocalpowerreached) {
              maxlocalpowerreached = Number(response.edlkw[index]);
            }
            if (Number(response.gensetkw[index]) > maxlocalpowerreached) {
              maxlocalpowerreached = Number(response.gensetkw[index]);
            }
            if (localStorage.getItem("designtype_of_" + mac) != "FSCOMPHYB") {
              if (
                Number(response.pvkw[index]) > 1000
                  ? 0
                  : Number(response.pvkw[index]) > maxlocalpowerreached
              ) {
                maxlocalpowerreached = Number(response.pvkw[index]);
              }
            } else {
              //total pv production when complex dispalying
              totalpvproduction = (
                Number(response.ogpvkw[index]) + Number(response.hybpvkw[index])
              ).toFixed(2);
              if (
                (totalpvproduction > 1000
                  ? 0
                  : Number(totalpvproduction) > Number(maxlocalpowerreached)) &&
                totalpvproduction != "NaN"
              ) {
                maxlocalpowerreached = totalpvproduction;
              }
            }
            if (Number(response.loadkw[index]) > maxlocalpowerreached) {
              maxlocalpowerreached = Number(response.loadkw[index]);
            }

            //calculated the minimum power reached
            if (Number(response.edlkw[index]) < minlocalpowerreached) {
              minlocalpowerreached = Number(response.edlkw[index]);
            }
            if (
              Number(response.gensetkw[index]) < -1000
                ? 0
                : Number(response.gensetkw[index]) < minlocalpowerreached
            ) {
              minlocalpowerreached = Number(response.gensetkw[index]);
            }
            if (localStorage.getItem("designtype_of_" + mac) != "FSCOMPHYB") {
              if (Number(response.pvkw[index]) < minlocalpowerreached) {
                minlocalpowerreached = Number(response.pvkw[index]);
              }
            } else {
              //total pv production when complex dispalying
              totalpvproduction = (
                Number(response.ogpvkw[index]) + Number(response.hybpvkw[index])
              ).toFixed(2);
              if (
                Number(totalpvproduction) < Number(minlocalpowerreached) &&
                totalpvproduction != "NaN"
              ) {
                minlocalpowerreached = totalpvproduction;
              }
            }

            if (Number(response.loadkw[index]) < minlocalpowerreached) {
              minlocalpowerreached = Number(response.loadkw[index]);
            }

            //calculate totaledlimported
            if (
              response.edlkw[index] != null &&
              response.edlkw[index] != undefined &&
              response.edlkw[index] != "" &&
              index <= returntimetoindexofconstantminutes
            ) {
              if (response.edlkw[index] > 0) {
                //imported
                totaledlin += Number(response.edlkw[index]) / 12;
              } else {
                //exported
                totaledlout += Number(response.edlkw[index]) / 12;
              }
            }
          }
          /*const { productionResults, consumptionResults } =
            calculateDailyEnergyArrays(
              pvkwpoints, // array of 288 values
              edlkwpoints, // array of 288 values
              gensetkwpoints, // array of 288 values
              loadkwpoints, // array of 288 values
              localStorage.getItem("BatCap_of_" + mac),
              totaledlin,
              totaledlout,
              returntimetoindexofconstantminutes,
              response.battcap[0],
              response.battcap[returntimetoindexofconstantminutes]
            );*/
          const summary = calculateDailySummary(
            pvkwpoints,
            loadkwpoints,
            gensetkwpoints,
            totaledlin,
            totaledlout,
            returntimetoindexofconstantminutes,
          );

          // update states
          setDailyEnergySummary(summary);
          //setProductionResults(productionResults);
          //setConsumptionResults(consumptionResults);
          //console.log("Production:", productionResults);
          //console.log("Consumption:", consumptionResults);
          settotaledlexported(totaledlout.toFixed(2) + " Kwh");
          settotaledlimported(totaledlin.toFixed(2) + " Kwh");
          let tempdata = [];
          if (
            localStorage
              .getItem("type_of_" + mac)
              .toLowerCase()
              .indexOf("amf") !== -1
          ) {
            tempdata.push({
              id: "EDL kW",
              name: "EDL kW",
              color: "steelblue",
              points: displayedDataKeys.includes("EDL kW") ? edlkwpoints : [],
            });
          }
          tempdata.push({
            id: "PV kW",
            name: "PV kW",
            color: "green",
            points: displayedDataKeys.includes("PV kW") ? pvkwpoints : [],
          });
          tempdata.push({
            id: "Genset kW",
            name: "Genset kW",
            color: "coral",
            points: displayedDataKeys.includes("Genset kW")
              ? gensetkwpoints
              : [],
          });
          tempdata.push({
            id: "Consumption Kw",
            name: "Consumption Kw",
            color: "purple",
            points: displayedDataKeys.includes("Consumption Kw")
              ? loadkwpoints
              : [],
          });
          if (
            localStorage.getItem("designtype_of_" + mac) == "FSHYB" ||
            localStorage.getItem("designtype_of_" + mac) == "FSCOMPHYB" ||
            localStorage.getItem("designtype_of_" + mac) == "FSHYBRBS"
          ) {
            tempdata.push({
              id: "Battery Capacity",
              name: "Battery Capacity",
              color: "olive",
              points: displayedDataKeys.includes("Battery Capacity")
                ? battcappoints
                : [],
            });
          }
          if (localStorage.getItem("designtype_of_" + mac) == "FSHYBRBS") {
            tempdata.push({
              id: "Load1",
              name: "Load1",
              color: "orange",
              points: displayedDataKeys.includes("Load1") ? Load1points : [],
            });
            tempdata.push({
              id: "Load2",
              name: "Load2",
              color: "palegreen",
              points: displayedDataKeys.includes("Load2") ? Load2points : [],
            });
            tempdata.push({
              id: "Load3",
              name: "Load3",
              color: "powderblue",
              points: displayedDataKeys.includes("Load3") ? Load3points : [],
            });
          } else if (
            localStorage.getItem("designtype_of_" + mac) == "FSCOMPHYB"
          ) {
            tempdata.push({
              id: "ongrid pv Kw",
              name: "ongrid pv Kw",
              color: "orange",
              points: displayedDataKeys.includes("ongrid pv Kw")
                ? OGIPVpoints
                : [],
            });
            tempdata.push({
              id: "hyb pv Kw",
              name: "hyb pv Kw",
              color: "cadetblue",
              points: displayedDataKeys.includes("hyb pv Kw")
                ? HybPVpoints
                : [],
            });
          }
          setNow(
            convertSecondsToHMS(
              returntimetoindexofconstantminutes * timeoutframe * 60,
            ),
          );
          //console.log(tempdata);
          setData(tempdata);
          if (localStorage.getItem("designtype_of_" + mac) == "FSHYBRBS") {
            setminipowerdatareached(Math.floor(minlocalpowerreached / 1) * 1);
            setmaxipowerdatareached(Math.ceil(maxlocalpowerreached / 1) * 1);
          } else {
            setminipowerdatareached(Math.floor(minlocalpowerreached / 5) * 5);
            setmaxipowerdatareached(Math.ceil(maxlocalpowerreached / 5) * 5);
          }
        }
      })
      .catch((err) => console.log(err));
  }

  const getdevicedate = async () => {
    let instanttimezone = timezone;
    //if (timezone == "") {
    instanttimezone = await gettimeaccordingtositelocation();
    timezone = instanttimezone;
    //}
    let date = new Date();
    //console.log(instanttimezone);
    if (
      instanttimezone != undefined &&
      (instanttimezone.includes("+") ||
        instanttimezone.includes("-") ||
        instanttimezone.toLocaleLowerCase() == "utc")
    ) {
      //for UTC as time zone format
      date = adjustUTCDateByOffset(instanttimezone);
    } else {
      //for country name as a time zone format
      date = new Date(
        new Date().toLocaleString("en-US", { timeZone: instanttimezone }),
      );
    }
    return date;
  };

  function convertSecondsToHMS(seconds) {
    //minute val
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    //const formattedSeconds = remainingSeconds.toString().padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}`; //:${formattedSeconds}
  }

  function fromindextohoursminutes(index) {
    let hoursmintuesoutput;
    let calculatedhours = Number(index).toFixed(2).split(".");
    //console.log("calculatedhours_" + calculatedhours);
    let tempmin = Number(("0." + calculatedhours[1]) * 60).toFixed(0);
    //console.log("tempmin" + tempmin);
    hoursmintuesoutput = calculatedhours[0] + ":" + tempmin;
    //console.log("hoursmintuesoutput" + hoursmintuesoutput);
    return hoursmintuesoutput;
  }

  const tickFormatter = (time) => {
    let timeString = time;
    if (typeof time !== "string") {
      // Assuming `time` is a JavaScript Date object, convert it to a string in "00:00:00" format
      const hours = time.getHours().toString().padStart(2, "0");
      const minutes = time.getMinutes().toString().padStart(2, "0");
      const seconds = time.getSeconds().toString().padStart(2, "0");
      timeString = `${hours}:${minutes}:${seconds}`;
    }
    const [hour, minute, second] = timeString.split(":");
    return `${hour}:${minute}:${second}`;
  };
  const formatTime = (timeStr) => {
    const [hour, minute, second] = timeStr.split(":");
    const date = new Date(); // Use a common date to provide a complete timestamp
    date.setHours(parseInt(hour, 10));
    date.setMinutes(parseInt(minute, 10));
    date.setSeconds(parseInt(second, 10));
    return date;
  };
  /*const CustomXAxisTick = (props) => {
    const { x, y, payload, tickCount } = props;
    const tickWidth = 100 / tickCount; // Adjust as needed

    const [hour, minute, second] = payload.value.split(":");
    const formattedTime = `${hour}:${minute}`;

    const textX = -tickWidth / 2; // Center the text within the tick width

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={textX}
          y={0}
          dy={16}
          textAnchor="middle"
          fill="#666"
          transform="rotate(-35)"
        >
          {formattedTime}
        </text>
      </g>
    );
  };*/

  const CustomXAxisTick = (props) => {
    const { x, y, payload } = props;

    // Validate and extract time components from payload.value
    const valueParts = payload.value ? payload.value.split(":") : [];
    const [hour = "00", minute = "00"] = valueParts; // Default to "00:00" if splitting fails
    const formattedTime = `${hour}:${minute}`;

    // Ensure x and y are valid numbers
    const validX = !isNaN(x) ? x : 0;
    const validY = !isNaN(y) ? y : 0;

    return (
      <g transform={`translate(${validX},${validY})`}>
        <text
          x={0} // Keep the text at the tick's x position without centering adjustment
          y={0}
          dy={16}
          textAnchor="middle"
          fill="#666"
          transform="rotate(-35)" // Adjust or remove rotation as needed
        >
          {formattedTime}
        </text>
      </g>
    );
  };

  const handleDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const requestchartlogfromsdcard = async () => {
    setRequestCheck(true);
    if (
      await manageRequest(
        "check",
        "Get Log",
        localStorage.getItem("token"),
        localStorage.getItem("username"),
        mqtt_topics.choosenmac,
      )
    ) {
      setRequestCheck(false);
      manageRequest(
        "add",
        "Get Log",
        localStorage.getItem("token"),
        localStorage.getItem("username"),
        mqtt_topics.choosenmac,
      );
      subscribeAndListenToMqttMessages();
      setLoadingStatus("Request Data...");
      props.mqttClient.publish(
        mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
        JSON.parse(
          JSON.stringify(
            '{ "action": "Get Log","directory":"/frontend/uploadSASLogs" ,"type":"chart","from":"' +
              formatDate(new Date(startDateRef.current)) +
              '","to":"' +
              formatDate(new Date(startDateRef.current)) +
              '","token":"' +
              localStorage.getItem("token") +
              '","username":"' +
              localStorage.getItem("username") +
              '"}',
          ),
        ),
      );
    } else {
      alert.show(
        mqtt_topics.choosenid + " is busy right now. Please try again later.",
        {
          type: "info",
          position: "middle",
        },
      );
      unsubscribeAndDoNotListenToMqttMessages();
    }
  };

  const browseotherdayforchart = async () => {
    //console.log("browseotherdayforchart");
    if (startDateRef.current) {
      let date = await getdevicedate();
      setDevicedate(date);
      if (
        (deviceSDRetrieveCompatible ||
          localStorage.getItem("designtype_of_" + mac).toLocaleUpperCase() !=
            "FSHYBRBS") &&
        !istoday(startDateRef.current, date)
      ) {
        //get chart log from sd card
        await requestchartlogfromsdcard();
      } else {
        get24hourslogtodevice(date);
      }
    }
  };

  function formatDate(date) {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  function sendAbortRequest() {
    if (loadingStatus != "") {
      props.mqttClient.publish(
        mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
        JSON.parse(JSON.stringify('{ "action": "Abort Get Log" }')),
      );
      finishedretrievinglogsfromsdcard();
      setLoadingStatus("Request abort ...");
      setStartDate(new Date().toISOString().split("T")[0]);
      //unsubscribeAndDoNotListenToMqttMessages();
    }
  }

  if (
    containsCON05 ||
    (localStorage.getItem("designtype_of_" + mac) &&
      localStorage.getItem("designtype_of_" + mac).includes("FS"))
  ) {
    if (data.length == 0) {
      return (
        <div className="container">
          <div className="col">
            <div>
              <center>
                <img
                  src={require("./../../../images/simpleloading.gif")}
                  className="simpleloadingview"
                />
                <p>
                  <strong>Loading Chart Diagram ...</strong>
                </p>
              </center>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row">
          <div className="col">
            <div
              className="card text-center bg-light graphdiagramcards"
              id="linechartcanvas"
              style={{
                display: data.length > 0 ? "block" : "none",
              }}
            >
              <div className="card-body ">
                <div className="App">
                  {(localStorage
                    .getItem("designtype_of_" + mac)
                    .toLocaleUpperCase() == "FSHYBRBS" ||
                    (deviceSDRetrieveCompatible &&
                      props.from == "display.js")) && (
                    <div>
                      <label>Browse for other days: </label>
                      <input
                        type="date"
                        style={{
                          width: "150px",
                          cursor: "pointer",
                          padding: "2px",
                          marginRight: "10px",
                          marginLeft: "10px",
                          border: "1px solid #ccc",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                        className=" btn-light btn-sm"
                        value={startDate}
                        max={devicedate}
                        onChange={handleDateChange}
                        onKeyDown={(e) => e.preventDefault()} // Disable keyboard input
                      />
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={browseotherdayforchart}
                        disabled={
                          deviceSDRetrieveCompatible && loadingStatus != ""
                        }
                      >
                        Go
                      </button>
                      {deviceSDRetrieveCompatible && (
                        <button
                          className="btn btn-secondary btn-sm"
                          style={{ margin: "10px" }}
                          onClick={sendAbortRequest}
                          disabled={loadingStatus == ""}
                        >
                          Abort
                        </button>
                      )}
                      <hr />
                    </div>
                  )}
                  {datafound && loadingStatus == "" && (
                    <div>
                      <strong>24 Hours Chart</strong>
                      {
                        <ResponsiveContainer width="100%" height={250}>
                          <LineChart width={500} height={300} data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                              dataKey="x"
                              /*
                        type="category"
                        scale="time"
                        tickFormatter={tickFormatter}*/
                              allowDuplicatedCategory={false}
                              stroke="lightslategrey"
                              tick={<CustomXAxisTick />}
                              interval={chartInterval}
                              tickCount={data.length} // Set tickCount to the number of data points
                            />
                            {localStorage
                              .getItem("designtype_of_" + mac)
                              .toLocaleUpperCase() != "FSOG" && (
                              <YAxis
                                yAxisId="left"
                                scale="linear"
                                type="number"
                                domain={[minbatterycapacity, 100]}
                                unit="%"
                                stroke="lightslategrey"
                              />
                            )}
                            <YAxis
                              yAxisId="right"
                              orientation="right"
                              scale="linear"
                              type="number"
                              domain={[
                                minipowerdatareached,
                                maxipowerdatareached,
                              ]}
                              unit="kW"
                              stroke="lightslategrey"
                            />
                            <Tooltip position={{ y: -150 }} />
                            <Legend
                              onClick={(e) => {
                                let dataKey = e.value;
                                if (displayedDataKeys.includes(dataKey)) {
                                  setDisplayedDataKeys(
                                    displayedDataKeys.filter(
                                      (key) => key !== dataKey,
                                    ),
                                  );
                                } else {
                                  setDisplayedDataKeys([
                                    ...displayedDataKeys,
                                    dataKey,
                                  ]);
                                }
                              }}
                            />
                            {data.map((line) => (
                              <Line
                                yAxisId={
                                  line.id == "Battery Capacity"
                                    ? "left"
                                    : "right"
                                }
                                key={line.id}
                                type="monotone"
                                data={line.points}
                                dataKey="y"
                                stroke={line.color}
                                name={line.name}
                                strokeWidth={1}
                                dot={false}
                              />
                            ))}
                            {localStorage
                              .getItem("designtype_of_" + mac)
                              .toLocaleUpperCase() != "FSHYBRBS" && (
                              <ReferenceArea
                                yAxisId="right"
                                x1={now}
                                x2={convertSecondsToHMS(288 * 5 * 60)}
                                y1={minipowerdatareached} //maxreturnedpower
                                y2={maxipowerdatareached} //maxpowerproduction
                                fill="thistle"
                                fillOpacity={0.3}
                              >
                                <Label
                                  value="Yesterday"
                                  offset={20}
                                  position="insideTop"
                                />
                              </ReferenceArea>
                            )}
                          </LineChart>
                        </ResponsiveContainer>
                      }
                      <p>
                        Click on a legend item to show/hide the corresponding
                        data series.
                      </p>
                      <hr />
                      {dailyEnergySummary && (
                        <div
                          style={{
                            textAlign: "center",
                            fontFamily: "Arial, sans-serif",
                          }}
                        >
                          <details
                            style={{
                              marginBottom: "12px",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              padding: "8px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <summary
                              style={{
                                cursor: "pointer",
                                fontWeight: "bold",
                                listStyle: "none",
                                color: "#007BFF",
                                transition: "color 0.2s",
                              }}
                              onMouseOver={(e) =>
                                (e.currentTarget.style.color = "#0056b3")
                              }
                              onMouseOut={(e) =>
                                (e.currentTarget.style.color = "#007BFF")
                              }
                            >
                              Insights On Daily Energy →
                            </summary>

                            {/* Production Section */}
                            <div
                              style={{ textAlign: "center", marginTop: "8px" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  justifyContent: "center",
                                  gap: "12px",
                                }}
                              >
                                <span style={cardStyle}>
                                  🌞 <strong>Solar:</strong>{" "}
                                  {dailyEnergySummary.dailySolarProduction} Kwh
                                </span>
                                <span style={cardStyle}>
                                  🏭 <strong>Generator:</strong>{" "}
                                  {dailyEnergySummary.dailyGeneratorProduction}{" "}
                                  Kwh
                                </span>
                                <span style={cardStyle}>
                                  ⚡ <strong>Load Consumption:</strong>{" "}
                                  {dailyEnergySummary.dailyLoadConsumption} Kwh
                                </span>
                                <span style={cardStyle}>
                                  🗼 <strong>Grid Feed-in:</strong>{" "}
                                  {dailyEnergySummary.dailyFeedIn} Kwh
                                </span>
                                <span style={cardStyle}>
                                  🛒 <strong>Grid Purchase:</strong>{" "}
                                  {dailyEnergySummary.dailyGridPurchase} Kwh
                                </span>
                              </div>
                            </div>
                          </details>
                        </div>
                      )}
                      <hr />
                    </div>
                  )}

                  {!datafound && (
                    <div>
                      <img
                        src={require("./../../../images/sadface.svg")}
                        className="simpleloadingview"
                      />
                      <br></br>
                      <strong>No Data Found!</strong>
                    </div>
                  )}
                  {loadingStatus != "" && (
                    <div>
                      <img
                        src={require("./../../../images/simpleloading.gif")}
                        className="simpleloadingview"
                      />
                      <br></br>
                      <strong>{loadingStatus}</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return null;
  }
};
const cardStyle = {
  background: "#f5f5f5",
  borderRadius: "12px",
  padding: "8px 14px",
  fontSize: "16px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
};
export default Chart;

/*
                      <div
                        style={{
                          display:
                            localStorage
                              .getItem("type_of_" + mac)
                              .toLowerCase()
                              .indexOf("amf") !== -1
                              ? "block"
                              : "none",
                        }}
                      >
                        <p>
                          Imported EDL Energy &asymp; {totaledlimported} |
                          Exported EDL Energy &asymp; {totaledlexported}
                        </p>
                      </div>

                       
                            <div
                              style={{
                                textAlign: "center",
                                marginBottom: "5px",
                                marginTop: "8px",
                              }}
                            >
                              <strong
                                style={{
                                  display: "block",
                                  marginBottom: "5px",
                                  fontSize: "18px",
                                }}
                              >
                                🔆 Daily Production: {productionResults.total}{" "}
                                Kwh
                              </strong>

                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  justifyContent: "center",
                                  gap: "12px",
                                }}
                              >
                                <span
                                  style={{
                                    background: "#f5f5f5",
                                    borderRadius: "12px",
                                    padding: "8px 14px",
                                    fontSize: "16px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  <strong>To Load:</strong>{" "}
                                  {productionResults.load.value} Kwh (
                                  <span className="greentext">
                                    {productionResults.load.percentage}%
                                  </span>
                                  ) <strong>To Grid:</strong>{" "}
                                  {productionResults.grid.value} Kwh (
                                  <span className="greentext">
                                    {productionResults.grid.percentage}%
                                  </span>
                                  ) <strong>To Battery:</strong>{" "}
                                  {productionResults.battery.value} Kwh (
                                  <span className="greentext">
                                    {productionResults.battery.percentage}%
                                  </span>
                                  )
                                </span>
                              </div>
                            </div>

                            
                            <div
                              style={{
                                textAlign: "center",
                                marginBottom: "5px",
                              }}
                            >
                              <strong
                                style={{
                                  display: "block",
                                  marginBottom: "5px",
                                  fontSize: "18px",
                                }}
                              >
                                ⚡ Daily Consumption: {consumptionResults.total}{" "}
                                Kwh
                              </strong>

                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  justifyContent: "center",
                                  gap: "12px",
                                }}
                              >
                                <span
                                  style={{
                                    background: "#f5f5f5",
                                    borderRadius: "12px",
                                    padding: "8px 14px",
                                    fontSize: "16px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  <strong>From Solar:</strong>{" "}
                                  {consumptionResults.solar.value} Kwh (
                                  <span className="bluetext">
                                    {consumptionResults.solar.percentage}%
                                  </span>
                                  ) <strong>From Grid:</strong>{" "}
                                  {consumptionResults.grid.value} Kwh (
                                  <span className="bluetext">
                                    {consumptionResults.grid.percentage}%
                                  </span>
                                  ) <strong>From Battery:</strong>{" "}
                                  {consumptionResults.battery.value} Kwh (
                                  <span className="bluetext">
                                    {consumptionResults.battery.percentage}%
                                  </span>
                                  ) <strong>From Generator:</strong>{" "}
                                  {consumptionResults.generator.value} Kwh (
                                  <span className="bluetext">
                                    {consumptionResults.generator.percentage}%
                                  </span>
                                  )
                                </span>
                              </div>
                            </div>
*/
